import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "filter__col"
}
const _hoisted_2 = { class: "filter__col-bg" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon icon__filter",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#filter" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_check_box_list = _resolveComponent("app-check-box-list")!
  const _component_range_slider = _resolveComponent("range-slider")!
  const _component_color_filter = _resolveComponent("color-filter")!

  return (!_ctx.filter)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", null, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.settings.dragFilterHere" })
          ])
        ])
      ]))
    : (_ctx.type === 'checkboxList')
      ? (_openBlock(), _createBlock(_component_app_check_box_list, {
          key: 1,
          modelValue: _ctx.model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model) = $event)),
          options: _ctx.options,
          type: _ctx.filter
        }, null, 8, ["modelValue", "options", "type"]))
      : (_ctx.type === 'rangeSlider')
        ? (_openBlock(), _createBlock(_component_range_slider, {
            key: 2,
            modelValue: _ctx.model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model) = $event)),
            options: _ctx.options,
            type: _ctx.filter
          }, null, 8, ["modelValue", "options", "type"]))
        : (_ctx.type === 'colorsList')
          ? (_openBlock(), _createBlock(_component_color_filter, {
              key: 3,
              modelValue: _ctx.model,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
              options: _ctx.options
            }, null, 8, ["modelValue", "options"]))
          : _createCommentVNode("", true)
}